import React, {useState, useEffect, useRef, useMemo} from "react";
import { Link , useParams, useNavigate, useLocation  } from "react-router-dom";
import Header from "layouts/Header";
import Footer from "layouts/Footer";
import {Links} from 'routes/PathLink'
import { periodData, APP_URL, APP_NAME } from "components/config/Common";
import Breadcrumb  from "components/Breadcrumb";
//import IndicesTable  from "../components/IndicesTable";
import Seo from 'components/seo/seo'
import StockActionTable from './StockActionTable'
import Helmet from 'react-helmet'
import { Select } from "antd";
import {
  useTopLosersQuery
} from 'data/home-data';


const TopLosers = () => {	
    const navigate = useNavigate();
    const {range, sector} = useParams()
    const [active, setActive] = useState(range);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(process.env.REACT_APP_PAGE_LIMIT);
    const [period, setPeriod] = useState(range);
    const [pageTitle, setPageTitle] = useState(null);
    const [metaDesc, setMetaDesc] = useState(null)
    const [timePhrase, setTimePhrase] = useState(null)
    const [schemaData, setSchemaData] = useState(null)
    const [sectorId, setSectorId] = useState(null)
    //console.log('params====',range, sector)


    const {
        data,
        sectors,
        metaData,        
        paginatorInfo,
        isLoading,
        error,
    } = useTopLosersQuery({ 
        period,
        sector_id:sectorId,
        limit: pageSize,
        page,
    });

    useEffect(() => {
        // Check if the 'range' from URL exists in periodData IDs
        const selectedPeriod = periodData.find(item => item.id === range);

        if (!selectedPeriod) {
            // Redirect to 404 if the param is invalid
            // replace: true prevents the user from going "back" to the invalid URL
            navigate('/404', { replace: true });
        }
        let pageTitle = selectedPeriod.label;

        const sectorName = sectors?.find(
            item => item.sector_slug === sector
        )?.sector_name;

        if (sector && sectors && !sectorName) {
            // Redirect to 404 if the param is invalid
            // replace: true prevents the user from going "back" to the invalid URL
            navigate('/404', { replace: true });
        }

        //console.log('selectedSector====',sectorName)
        
        //console.log('page name====', pageTitle)
        // Adjust phrasing: "from Yesterday" vs "over the last 6 Months"
        
        const timePhrase = pageTitle === "Yesterday" ? "Yesterday" : `${pageTitle}`;
        const descriptionSuffix = pageTitle === "Yesterday" ? "during the last trading session" : `over the past ${pageTitle}`;

        let sectorTitle = sectorName ? ` in ${sectorName} Sector` : ''

        let seoTitle = `${timePhrase} Top Losers${sectorTitle}`;
        

        const seoDescription = `See which stocks are falling the most ${descriptionSuffix}${sectorTitle}. Analyze the biggest market decliners, price pullbacks, and potential oversold opportunities for ${timePhrase}${sectorTitle}.`;

        
        setPageTitle(seoTitle);
        setMetaDesc(seoDescription)
        setTimePhrase(timePhrase)

        set_schema_date(seoTitle)

    }, [range, navigate, sector, sectors]);

    const onPagination = (current) => {
        //console.log("current Page",current);
        setPage(current);
    }
    const onPageSize = (value) => {
        setPageSize(value);
        setPage(1);
    }  
    
    

    useEffect(() => {        
        setPeriod(range)
        setActive(range)
        setPage(1);
        if(!sector){
            setSectorId(null)
        }
    }, [range]);

    useEffect(() => {
        
        if(!sectorId){
            const selectedSector = sectors?.find(
                item => item.sector_slug === sector
            );
        
            setSectorId(selectedSector?.sector_id)
        }
    }, [sectors, sector]);

    //console.log('sectors====',sectors)
    //console.log('7days data',weekData)
    //console.log('one year data',yearData)

    /* const getHistoricData = (period) => {
        //console.log('period', period)
        setPeriod(period)
        setActive(period)
        
    } */

    const totalPages = Math.ceil(paginatorInfo?.total / pageSize);

    //console.log("most active list data====:", data);

    const breadcrumb = [
        {
            name:'Home',
            link:`${process.env.REACT_APP_URL}`,
        },
        {
            name:`${pageTitle}`,
            link:null
        }
    ]
    
    const set_schema_date = (name) => {
        const mergedSchema = {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "@id": `${window.location.href}#breadcrumb`,
            "itemListElement": [
                {
                "@type": "ListItem",
                "position": 1,
                "item": {
                    "@id": process.env.REACT_APP_URL,
                    "name": "Home"
                }
                },
                {
                "@type": "ListItem",
                "position": 2,
                "item": {
                    "@id": window.location.href,
                    "name": `${name}`
                }
                }
            ]
        };
        setSchemaData(mergedSchema)
    }

    const setSelectedSector = (val) => {
        //console.log('setSelectedSector===', val)
        setSectorId(val)
        const filteredStocks = val
        ? sectors.filter(stock => stock.sector_id === val)[0]
        : sectors;
        //console.log('filteredStocks===', filteredStocks)
        let path = `/top-losers/${range}` 
        if(val > 0){
            path = `${path}/${filteredStocks.sector_slug}`
        }

        navigate(path, { replace: true });
    }

    return (
        <>
        <Seo 
            title={`${pageTitle}: Stocks with the Biggest Price Declines - ${APP_NAME}`}
            desc={`${metaDesc}`}
            url={window.location.href}
            
          />
        <Helmet>
            {/* Combined Schema for SEO Efficiency */}
            <script type="application/ld+json">
                {JSON.stringify(schemaData)}
            </script>
        </Helmet>
        <Header  />        
        <div className="space-y-5 px-5">
            <Breadcrumb breadcrumb={breadcrumb} />
            <section className="bg-white shadow-sm z-50 rounded-xl p-5">

                <h2 className="text-2xl">{pageTitle} : Stocks with the Biggest Price Declines</h2>
                <div className="my-3 text-gray-600">{metaDesc}</div>
                <div className="w-full flex flex-col items-start lg:flex-row lg:items-center justify-between my-3">
                    <div className="flex gap-2 py-5 lg:py-0">
                        {sector ?
                        <>
                        <Link className="text-accent text-sm hover:underline" to={`${APP_URL}/most-active-stocks/${range}/${sector}`}>Most Active</Link>
                        <Link className="text-accent text-sm hover:underline" to={`${APP_URL}/top-gainers/${range}/${sector}`}>Top Gainers</Link>
                        </>
                        :
                        <>                        
                        <Link className="text-accent text-sm hover:underline" to={`${APP_URL}/most-active-stocks/${range}`}>Most Active</Link>
                        <Link className="text-accent text-sm hover:underline" to={`${APP_URL}/top-gainers/${range}`}>Top Gainers</Link>
                        </>
                        }
                    </div>
                    <div className="text-gray-600 text-sm">
                        { metaData && <>{metaData?.start_date} - {metaData?.end_date}</>}
                    </div>
                    <div className="flex items-center gap-2">
                        <div className="text-gray-600 text-sm">Sectors:</div>
                        <Select
                            showSearch
                            allowClear
                            optionFilterProp="label"
                            placeholder="Select Sector"
                            style={{ width: 220 }}
                            onChange={(value) => setSelectedSector(value)}
                            value={sectorId}
                            filterOption={(input, option) =>
                                option?.label?.toLowerCase().includes(input.toLowerCase())
                            }
                            options={[
                                { value: null, label: "All Sectors", slug: null },
                                ...(sectors ?? []).map(sector => ({
                                    value: sector.sector_id,
                                    label: sector.sector_name,
                                    slug: sector.sector_slug
                                }))
                            ]}
                        />
                    </div>
                    <div class="inline-flex flex-wrap rounded-base shadow-xs -space-x-px my-5" role="group">
                        {periodData.map((val, key) => (
                        <>
                        {sector ?
                        <Link key={`btn-${key}`} to={`${APP_URL}/top-losers/${val.id}/${sector}`} type="button" class={`${active == val.id ? 'bg-accent text-white' : 'bg-neutral-primary-soft'} text-body  border border-accent hover:bg-accent hover:text-white leading-5 rounded-s-base text-sm px-3 py-2 focus:outline-none`}>
                            {val.label}
                        </Link>
                        :
                        <Link key={`btn-${key}`} to={`${APP_URL}/top-losers/${val.id}`} type="button" class={`${active == val.id ? 'bg-accent text-white' : 'bg-neutral-primary-soft'} text-body  border border-accent hover:bg-accent hover:text-white leading-5 rounded-s-base text-sm px-3 py-2 focus:outline-none`}>
                            {val.label}
                        </Link>
                        }
                        </>
                        ))
                        }
                    </div>
                </div>
                
                <StockActionTable
                    data={data} 
                    pageSize={pageSize} 
                    isLoading={isLoading} 
                    paginatorInfo={paginatorInfo}
                    totalPages={totalPages}
                    onPagination={onPagination}
                    onPageSize={onPageSize}
                />
            </section>    
        </div>
        <Footer />
        </>
    )
}

export default TopLosers;